module.exports = __webpack_public_path__ + "assets/img/34_697_big.715fbaad.jpg";